import React from "react";
import styles from './Contact.module.css'
function Footer() {
  return (
    <div>
      <footer class="text-gray-400 body-font">
        <div class="container px-5 py-8 mx-auto flex items-center sm:flex-row flex-col">

          <h1 className={styles.thanks}>Thanks for visit</h1>
          
        </div>
      </footer>
    </div>
  );
}

export default Footer;
